/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Notification} from '../models/Notification';

export interface GetUserActiveNotifications$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserActiveNotificationsRequest = createAction<PayloadData<void>>('USER_INTERNAL_NOTIFICATION__GET_USER_ACTIVE_NOTIFICATIONS__REQUEST');
export const getUserActiveNotificationsSuccess = createAction<PayloadData<Array<Notification>>>('USER_INTERNAL_NOTIFICATION__GET_USER_ACTIVE_NOTIFICATIONS__SUCCESS');
export const getUserActiveNotificationsFailure = createAction<PayloadData<Error, void, true>>('USER_INTERNAL_NOTIFICATION__GET_USER_ACTIVE_NOTIFICATIONS__FAILURE');

export const getUserActiveNotificationsActions = [
    getUserActiveNotificationsRequest,
    getUserActiveNotificationsSuccess,
    getUserActiveNotificationsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserActiveNotifications = (config?: GetUserActiveNotifications$Config) => {
    return {
        CALL_API: {
            types: getUserActiveNotificationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/internal-notifications/user/active`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetUserNotifications$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserNotificationsRequest = createAction<PayloadData<void>>('USER_INTERNAL_NOTIFICATION__GET_USER_NOTIFICATIONS__REQUEST');
export const getUserNotificationsSuccess = createAction<PayloadData<Array<Notification>>>('USER_INTERNAL_NOTIFICATION__GET_USER_NOTIFICATIONS__SUCCESS');
export const getUserNotificationsFailure = createAction<PayloadData<Error, void, true>>('USER_INTERNAL_NOTIFICATION__GET_USER_NOTIFICATIONS__FAILURE');

export const getUserNotificationsActions = [
    getUserNotificationsRequest,
    getUserNotificationsSuccess,
    getUserNotificationsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserNotifications = (config?: GetUserNotifications$Config) => {
    return {
        CALL_API: {
            types: getUserNotificationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/internal-notifications/user`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface MarkNotificationRead$Request {
    notificationId: string;
    userId: number;
}

export interface MarkNotificationRead$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const markNotificationReadRequest = createAction<PayloadData<void, MarkNotificationRead$Request>>('USER_INTERNAL_NOTIFICATION__MARK_NOTIFICATION_READ__REQUEST');
export const markNotificationReadSuccess = createAction<PayloadData<void, MarkNotificationRead$Request>>('USER_INTERNAL_NOTIFICATION__MARK_NOTIFICATION_READ__SUCCESS');
export const markNotificationReadFailure = createAction<PayloadData<Error, MarkNotificationRead$Request, true>>('USER_INTERNAL_NOTIFICATION__MARK_NOTIFICATION_READ__FAILURE');

export const markNotificationReadActions = [
    markNotificationReadRequest,
    markNotificationReadSuccess,
    markNotificationReadFailure
] as const;

/**
 * @param {string} meta.notificationId Notification id
 * @param {number} meta.userId User id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const markNotificationRead = (meta: MarkNotificationRead$Request, config?: MarkNotificationRead$Config) => {
    return {
        CALL_API: {
            types: markNotificationReadActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/internal-notifications/${meta.notificationId}/users/${meta.userId}/read`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

